/**
 * DEPRECATED-modify-step-comment-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Comment, Visibility } from "../../../intake-form/comment";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeprecatedModifyStepCommentRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DEP_REQ_MODIFY_STEP_COMMENT;
	public static tag : MessageTag = MessageTag.DEP_REQ_MODIFY_STEP_COMMENT;

  public isPublic : boolean;
  public groupIds : number[];

  /**
   * Construct a new {@link ModifyStepCommentRequest}.
   */
  constructor (
    public stepId : number,
    public commentId : number,
    public comment : string,
    visibility : Visibility,
    selfGroupIds : number[]
  )
  {
    super();
    Comment.applyVisibilityToMessage(this, visibility, selfGroupIds);
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/DEPRECATED-modify-step-comment-request.ts